<template>
    <div class="creation-recla">
        <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">
        <nav v-if="!paramsMotifEntreeSet" aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{name: 'home'}">Menu</router-link></li>
                <li v-if="selectedCategory" title="Catégorie" class="breadcrumb-item"><router-link :to="{name: 'categories'}"> {{selectedCategory}}</router-link></li>
                <li v-if="selectedType" title="Type" class="breadcrumb-item"><router-link :to="{name: 'types'}"> {{selectedType}}</router-link></li>
                <li v-if="selectedNature" title="Nature" class="breadcrumb-item"><router-link :to="{name: 'natures'}"> {{selectedNature}}</router-link></li>
                <li v-if="selectedMotif" title="Motif" class="breadcrumb-item"><router-link :to="{name: 'motifs'}"> {{selectedMotif}}</router-link></li>
                <li v-if="selectedEntree" title="Entrée" class="breadcrumb-item"><router-link :to="{name: 'adresse'}"> {{selectedEntree}}</router-link></li>
            </ol>
        </nav>
        
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        </b-overlay>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "CreationRecla",
        computed : {
            ...mapGetters('categories', ['selectedCategory']),
            ...mapGetters('types', ['selectedType']),
            ...mapGetters('natures', ['selectedNature']),
            ...mapGetters('motifs', ['selectedMotif']),
            ...mapGetters('entrees', ['selectedEntree']),
            ...mapGetters('logements', ['logements']),
            ...mapGetters('partenaires', ['partenaires']),
            showOverlay() {
                if (this.logements != JSON.stringify([]))
                    return false
                else
                    return true
            },
            paramsMotifEntreeSet(){
                return (this.$route.params.motif && this.$route.params.identree)
            }
        },
        methods: {
            ...mapActions('title', ['setTitle']),
            ...mapActions('logements', ['loadLogementsFromAPI'])
        },
        mounted() {
            this.setTitle('Saisie sollicitation')
            this.loadLogementsFromAPI(this.partenaires)
        }
    }
</script>

<style scoped>

    @import "../assets/icon-list.css";

    .creation-recla{
        margin: 0px 10px;
    }
</style>